<template>
  <page-edicion :fluid="false">
    <page-header :title="oferta.descripcion" :subtitle="`${oferta.codigo} v${oferta.numeroVersion}`" @back="volver()" />

    <h3>Ganar oferta</h3>

    <b-row>
      <b-col>
        <b-form-group label="Código">
          <b-form-input v-model="oferta.codigo" readonly />
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group label="Versión">
          <b-form-input v-model="oferta.numeroVersion" readonly />
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <b-form-group label="Unidad de negocio">
          <b-form-input v-model="unidadNegocio.nombreComercial" readonly />
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group label="Cliente">
          <b-form-input v-model="cliente.nombre" readonly />
        </b-form-group>
      </b-col>
    </b-row>

    <div>
      <div v-if="!clienteTieneDatosCompletos">
        <b-alert variant="danger" show>
          <b>NO SE PUEDE GANAR ESTA OFERTA</b><br />
          <b>Los datos del cliente asociados a esta oferta no están completos</b>
          <br />
          ¿Quiere acceder a la ficha y completarlos?
        </b-alert>
        <b-button @click="cancelar()"> <v-icon width="16" name="arrow-left" /> Volver </b-button>
        <b-button class="ml-2" variant="primary" @click="verCliente()">
          Ir al cliente para completar los datos
        </b-button>
      </div>

      <div v-else>
        <b-form ref="form" @submit.prevent="submit">
          <b-form-group label="Fecha ganada">
            <b-form-datepicker v-model="ganadaEl" required />
          </b-form-group>

          <b-form-group label="Añadir Orden de compra" v-show="esAdmin">
            <b-form-file
              ref="file"
              accept=""
              placeholder="Elija un documento y arrástrelo aquí..."
              drop-placeholder="Suelte aquí el documento..."
              browse-text="Explorar"
              @input="actualizarOrdenCompra"
            />
          </b-form-group>

          <b-form-group>
            <b-form-checkbox switch size="lg" v-model="cartaBienvenida">
              <small class="mt-2">Enviar Carta de bienvenida</small>
            </b-form-checkbox>
          </b-form-group>

          <b-form-group label="Motivo">
            <b-form-select v-model="motivoCierreId" :options="motivosCierre" required />
          </b-form-group>

          <div class="text-right">
            <b-button variant="success" :disabled="!puedeGanar" type="submit"> Ganar Oferta </b-button>
            <b-button class="ml-2" @click="cancelar()"> Cancelar </b-button>
          </div>
        </b-form>
      </div>
    </div>
  </page-edicion>
</template>

<script>
import { mapState } from "pinia";
import { useSessionStore } from "@/stores/SessionStore";
import * as ofertasApi from "@/services/ofertas";

export default {
  computed: {
    ...mapState(useSessionStore, ["esAdmin"]),
    puedeGanar() {
      return (
        !this.oferta.perdida &&
        this.oferta.entregada &&
        !this.oferta.ganada &&
        (!this.oferta.caducada || (this.oferta.caducada && this.esAdmin))
      );
    },
  },
  data() {
    return {
      ganadaEl: new Date(),
      ordenCompra: {},
      cartaBienvenida: false,
      oferta: {},
      cliente: {},
      ofertaBase: {},
      unidadNegocio: {},
      motivoCierreId: null,
      clienteTieneDatosCompletos: false,
      motivosCierre: [],
    };
  },
  methods: {
    cancelar() {
      this.volver();
    },
    volver() {
      this.$router.push("/ofertas");
    },
    async cargarOferta(id) {
      const data = await ofertasApi.cargarCompleta(id);
      this.oferta = data.oferta;
      this.cliente = data.cliente;
      this.ofertaBase = data.ofertaBase;
      this.unidadNegocio = data.unidadNegocio;
      this.clienteTieneDatosCompletos = data.clienteTieneDatosCompletos;

      const response = await this.$backend.get("/motivosCierreOferta/comboParaGanar");
      this.motivosCierre = response.data;
    },
    async submit() {
      if (this.ganadaEl == "") {
        return this.$messages.alert("Seleccione una fecha.");
      }

      await this.$backend.post("ofertas/ganarVersion", {
        ofertaId: this.oferta.id,
        ganadaEl: this.ganadaEl,
        ordenCompra: this.ordenCompra,
        cartaBienvenida: this.cartaBienvenida,
        motivoCierreId: this.motivoCierreId,
      });

      this.$messages.success(`Oferta ganada: ${this.oferta.descripcion}`);
      this.volver();
    },
    actualizarOrdenCompra(fichero) {
      var name = "";
      name = fichero.name;
      this.enviarFichero(name, fichero);
    },
    enviarFichero(nombre, fichero) {
      var reader = new FileReader();

      reader.onload = (e) => {
        this.ordenCompra = {
          name: nombre,
          content: e.target.result,
        };
      };
      reader.readAsDataURL(fichero);
    },
    verCliente() {
      this.$router.push("/clientes/editar/" + this.cliente.id);
    },
  },
  watch: {
    "$route.params": {
      handler() {
        this.cargarOferta(this.$route.params.id);
      },
      immediate: true,
    },
  },
};
</script>
